<template>
    <div class="contenedor_modal">
        <div class="contenedor_modal_cuerpo">
            <div class="contenedor_modal_cabecera">
                <b-button type="button" size="sm" variant="danger" v-shortkey="['esc']" @shortkey="cerrar"
                    @click="cerrar"><i class="fas fa-times"></i></b-button>
            </div>

            <b-container fluid="">
                <form @submit.prevent="guardar">
                    <b-row>
                        <div class="col-sm-12 mt-3">
                            <h3>
                                Nueva sucursal
                            </h3>
                        </div>

                        <div class="col-sm-10 mt-3">
                            <label for="" class="form-label">Nombre</label>
                            <input type="text" id="campo_sucursal_nombre" class="form-control form-control-sm"
                                v-model="nombre" required>
                        </div>
                        <div class="col-sm-2 mt-3">
                            <label for="" class="form-label">Código</label>
                            <input type="text" id="campo_sucursal_codigo" class="form-control form-control-sm"
                                v-model="codigo" required>
                        </div>
                        <div class="col-sm-12 mt-3">
                            <label for="" class="form-label">Dirección</label>
                            <input type="text" class="form-control form-control-sm" v-model="direccion">
                        </div>

                        <div class="col-sm-12 mt-3 mb-3 d-flex justify-content-end">
                            <b-button type="submit" size="sm" variant="outline-dark">Guardar</b-button>
                        </div>
                    </b-row>

                </form>
            </b-container>

        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex'
    export default {
        name: 'CrearSucursal',
        data() {
            return {
                nombre: '',
                codigo: '',
                direccion: ''
            }
        },
        methods: {
            cerrar() {
                this.$emit('salir')
            },
            async guardar() {
                let f = {
                    api: `sucursales`,
                    formulario: {
                        nombre: this.nombre.toUpperCase().trim(),
                        codigo: this.codigo,
                        direccion: this.direccion == '' ? 'N/D' : this.direccion.trim()
                    }
                }

                await this.guardar_data(f)
                await this.$emit('actualizar')

                this.nombre = ''
                this.codigo = ''
                this.direccion = ''

                document.getElementById('campo_sucursal_nombre').focus()
            },
            ...mapActions(['guardar_data'])
        },
        mounted() {
            document.getElementById('campo_sucursal_nombre').focus()
        },
    }
</script>

<style></style>